export default __webpack_public_path__ + "static/media/bat-logo-white.e81ba329.svg";